module.exports = __webpack_public_path__ + "img/GAME_NATIONWIDETOUR1.3dfe8b9c.jpg";